<template>
  <div class="configurator">
    <Nav class="no-fixed-nav" />
    <div class="nav-spacer fixed-pos" />
    <div class="container card configurator-card">
      <div class="card-body">
        <!-- Header -->
        <div class="card-head">
          <div class="head custom-headline">
            <h1 v-if="step === -1" v-text="$ml.get('title')"></h1>
            <h1 v-else>{{ rutschenName }}</h1>
          </div>
          <!-- navigation buttons start -->
          <div v-if="step !== -1" class="desktop navigation-buttons">
            <button
              class="btn abort-btn nav-btn"
              :class="{ disabled: step === 0 }"
              style="margin-right: 5px"
              @click="nextStep(--step)"
              v-text="$ml.get('btnBack')"
            ></button>
            <button
              v-if="step !== possibleEffects.length"
              class="btn start-btn nav-btn"
              :class="{
                disabled: isValidStep(step),
              }"
              style="margin-left: 5px"
              @click="nextStep(++step)"
              v-text="$ml.get('btnProceed')"
            ></button>
            <!--
            <b-button
              v-if="step !== possibleEffects.length"
              class="btn confirm-button"
              @click="nextStep(++step)"
            >
              CHEAT
            </b-button>
            -->
            <button
              v-if="step === possibleEffects.length"
              class="btn start-btn nav-btn"
              :class="{ disabled: pending || selectedMusic === '' }"
              style="margin-left: 5px; width: 170px"
              @click="saveConfig"
            >
              <span
                v-if="!$route.query.overview"
                v-text="$ml.get('streckeErstellen')"
              ></span>
              <span v-else v-text="$ml.get('aenderungenSpeichern')"></span>
            </button>
          </div>
          <!-- navigation buttons end -->
        </div>
        <!-- Header end -->
        <hr class="desktop-hr" />
        <!-- Menu start-->
        <div class="menu">
          <div
            class="menu-entry start"
            :class="{ active: step === -1 }"
            @click="nextStep(-1)"
          >
            Start
          </div>
          <div v-for="(config, index) in possibleEffects" :key="config.id">
            <div
              class="menu-entry"
              :class="{
                disabled: completedStep < index,
                active: step === index,
              }"
              @click="nextStep(config.id)"
              v-text="index + 1 + '.' + $ml.get('abschnitt')"
            ></div>
          </div>
          <div
            class="menu-entry music"
            :class="{
              disabled: completedStep < possibleEffects.length,
              active: step === possibleEffects.length,
            }"
            @click="nextStep('music')"
            v-text="possibleEffects.length + 1 + '.' + $ml.get('musik')"
          ></div>
        </div>
        <!-- menu end -->
        <hr />
        <!-- Starting page start -->
        <ConfiguratorStartSpree
          v-if="step === -1"
          :name="rutschenName"
          @start="updateName"
          @cancel="$router.push('/')"
        />
        <!-- Starting page end -->
        <!-- Description & model start -->
        <div v-if="step !== -1" class="description">
          <div v-if="step !== steps.length - 1" class="description-container">
            <h4>{{ step + 1 }}. {{ possibleEffects[step].effect_name }}</h4>
            <div v-if="step === 0" v-text="$ml.get('Instruction1')"></div>
            <div v-else-if="step === 1" v-text="$ml.get('Instruction2')"></div>
            <div v-else-if="step === 2" v-text="$ml.get('Instruction3')"></div>
            <div v-else-if="step === 3" v-text="$ml.get('Instruction4')"></div>
            <div v-else-if="step === 4" v-text="$ml.get('Instruction5')"></div>
          </div>
          <div v-else class="description-container">
            <h4 v-text="$ml.get('title6')"></h4>
            <div v-html="$ml.get('Instruction6')"></div>
          </div>
          <div class="description-picture">
            <Overview
              v-if="step !== steps.length - 1"
              :index="step"
              :color="
                typeof colorValue[step] !== 'undefined'
                  ? colorValue[step].colorName
                  : ''
              "
              class="overview"
            />
            <img v-else src="../assets/spree/slider.jpg" alt="background01" />
            <!--<img
              v-if="step !== steps.length - 1"
              src="../assets/rutsche-render.jpg"
              alt="Abschnitts Position"
            />-->
          </div>
        </div>
        <!-- Description & model end -->
        <div v-if="step !== -1">
          <hr />
        </div>
        <!-- Last Page start -->
        <div v-if="step === steps.length - 1" class="configurator-wrapper">
          <div class="configurator-left tiles">
            <EffectTile
              v-for="(effect, index) in possibleEffects"
              :key="index + effect.effect_name"
              :name="index + 1 + '. ' + effect.effect_name"
              :effect="
                typeof programValue[index] !== 'undefined'
                  ? programValue[index].value_description
                  : ' '
              "
              :index="index"
              :color="
                typeof colorValue[index] !== 'undefined'
                  ? colorValue[index].colorName
                  : ' '
              "
              @select="nextStep"
            />
          </div>
          <div class="configurator-right music">
            <div class="description-picture overview-svg">
              <Overview
                :overview="true"
                :colorarray="colorValue"
                class="overview"
              />
            </div>
            <div class="music-header" v-text="$ml.get('music')"></div>
            <div class="card-input-wrapper music-wrapper">
              <div class="music-select-wrapper">
                <div
                  class="music-description"
                  v-text="$ml.get('musicDescription')"
                ></div>
                <b-input-group id="input-music-group">
                  <b-input-group-prepend>
                    <span class="input-group-text">
                      <MusicIcon title />
                    </span>
                  </b-input-group-prepend>
                  <b-form-select
                    id="input-music"
                    v-model="selectedMusic"
                    :options="musicOptions"
                    required
                    class="input-with-icon"
                    @change="updateMusicPath"
                  >
                    <template slot="first">
                      <option
                        :value="''"
                        disabled
                        v-text="$ml.get('musicChoice')"
                      ></option>
                    </template>
                  </b-form-select>
                </b-input-group>
              </div>
            </div>
            <MusicPlayer :path="selectedMusicPath" />
          </div>
        </div>
        <!-- Last Page end -->
        <!-- configurations -->
        <div
          v-if="step !== -1 && step !== steps.length - 1"
          class="configurator-wrapper"
        >
          <div class="configurator-left">
            <template>
              <!-- automatic generation of effects-->
              <div v-for="(effect, index) in possibleEffects" :key="effect.id">
                <template v-if="step === index">
                  <!-- user input -->
                  <div
                    v-for="(param, paramIdx) in effect.params"
                    :key="param.param_id + paramIdx"
                    class="effect"
                  >
                    <!-- Taktgeschwindigkeit -->
                    <div
                      v-if="
                        param.param_id.toLowerCase() === 'taktgeschwindigkeit'
                      "
                    >
                      <div
                        class="effect-headline"
                        v-text="param.param_name"
                      ></div>
                      <SpeedChooserMulti
                        v-if="param.subIndex === 0 || param.subIndex"
                        :data="param.values"
                        :index="index"
                        :subIndex="param.subIndex"
                        :selected="speedValue[index]"
                        style="margin-bottom: 10px"
                        @input="changeSpeedValueMulti"
                      />
                      <SpeedChooser
                        v-else
                        :data="param.values"
                        :index="index"
                        :selected="speedValue[index]"
                        style="margin-bottom: 10px"
                        @input="changeSpeedValue"
                      />
                      <div class="slider-info">
                        <div v-text="$ml.get('langsam')"></div>
                        <div v-text="$ml.get('normal')"></div>
                        <div v-text="$ml.get('schnell')"></div>
                      </div>
                    </div>
                    <!-- programm -->
                    <div
                      v-if="param.param_id.toLowerCase() === 'programmablauf'"
                    >
                      <div
                        class="effect-headline"
                        v-text="$ml.get('effekt')"
                      ></div>
                      <div>
                        <ProgramChooser
                          :index="index"
                          :programs="param.values"
                          :selectedprogram="programValue[index]"
                          @input="changeProgramValue"
                        />
                      </div>
                    </div>
                    <!-- farbe -->
                    <div v-if="param.param_id.toLowerCase() === 'farbe ring'">
                      <div
                        class="effect-headline"
                        v-text="$ml.get('color')"
                      ></div>
                      <ColorChooser
                        :index="index"
                        :colors="param.values"
                        :selectedcolor="colorValue[index]"
                        @input="changeColorValue"
                      />
                      <!--{{ colorValue.colorName }} -->
                    </div>
                  </div>
                </template>
              </div>
            </template>
          </div>
          <div class="configurator-right">
            <Visualization
              :color="
                typeof colorValue[step] !== 'undefined'
                  ? colorValue[step].colorName
                  : ''
              "
              :speed="
                typeof speedValue[step] !== 'undefined'
                  ? speedValue[step].value_description || speedChooserMultiSet
                  : 'normal'
              "
              :program="
                typeof programValue[step] !== 'undefined'
                  ? programValue[step].value_description
                  : ''
              "
              :slide-part="step"
              :index="step"
            />

            <!--<img
              src="../assets/bg_90.png"
              alt="config-image"
              class="config-image"
            />-->
          </div>
        </div>
      </div>
    </div>
    <div v-if="step !== -1" class="container mobile-fixed-menu">
      <div class="navigation-buttons">
        <button
          class="btn abort-btn nav-btn"
          :class="{ disabled: step === 0 }"
          style="margin-right: 5px"
          @click="nextStep(--step)"
          v-text="$ml.get('btnBack')"
        ></button>
        <button
          v-if="step !== possibleEffects.length"
          class="btn start-btn nav-btn"
          :class="{
            disabled: isValidStep(step) && step < 3,
          }"
          style="margin-left: 5px"
          @click="continueStep"
          v-text="$ml.get('btnProceed')"
        ></button>
        <button
          v-if="step === possibleEffects.length"
          class="btn start-btn nav-btn m-extended"
          :class="{ disabled: pending || selectedMusic === '' }"
          @click="saveConfig"
        >
          <span
            v-if="!$route.query.overview"
            v-text="$ml.get('streckeErstellen')"
          ></span>
          <span v-else v-text="$ml.get('aenderungenSpeichern')"></span>
        </button>
        <div v-if="pending">Please wait...</div>
      </div>
    </div>
    <div v-if="step !== -1" class="footer-buttons">
      <div class="footer-question" v-text="$ml.get('frageZufrieden')"></div>
      <button class="btn back-button" @click="$router.push('/')">
        <span
          v-if="!$route.query.overview"
          v-text="$ml.get('streckeVerwerfen')"
        ></span>
        <span v-else v-text="$ml.get('aenderungenVerwerfen')"></span>
        <CloseIcon title />
      </button>
    </div>
    <hr class="bottom-hr desktop-hr" />
    <Footer />
    <div class="mobile-footer" />
  </div>
</template>

<script>
import Nav from "../components/Nav";
import ConfiguratorStartSpree from "../components/ConfiguratorStartSpree";
import ColorChooser from "../components/ColorChooser";
import ProgramChooser from "../components/ProgramChooser";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import webconfig from "../helper/webconfigSpree";
import Footer from "../components/Footer";
import CloseIcon from "vue-material-design-icons/Close";
import EffectTile from "../components/EffectTile";
import Overview from "../components/SlideOverviewSpree";
import SpeedChooser from "../components/SpeedChooser";
import SpeedChooserMulti from "../components/SpeedChooserMulti";
import MusicIcon from "vue-material-design-icons/Music";
import MusicPlayer from "../components/MusicPlayer";
import Visualization from "../components/VisualizationSpree";
import { MLBuilder } from "vue-multilanguage";

export default {
  name: "Configurator",
  components: {
    Nav,
    ConfiguratorStartSpree,
    ColorChooser,
    ProgramChooser,
    Footer,
    CloseIcon,
    EffectTile,
    Overview,
    SpeedChooser,
    SpeedChooserMulti,
    MusicIcon,
    MusicPlayer,
    Visualization,
  },
  data() {
    return {
      step: -1,
      steps: [],
      completedStep: -1,
      rutschenName: "",
      possibleEffects: webconfig.effects,
      speedValue: [],
      speedChooserMultiSet: null,
      colorValue: [],
      programValue: [],
      selectedMusic: "",
      musicOptions: [],
    };
  },
  computed: {
    ...mapGetters("configurations", [
      "configurations",
      "getConfigByIndex",
      "getConfigByName",
      "selectedConfig",
      "pending",
      "songs",
    ]),
    selectedMusicPath() {
      let option = this.musicOptions.find(
        (x) => x.value === this.selectedMusic
      );
      if (typeof option !== "undefined") return option.url;
      else return "";
    },
    mlInstruction1() {
      return new MLBuilder("instruction1")
        .with("step", this.step + 1)
        .with("nextstep", this.step + 2);
    },
    mlInstruction2() {
      return new MLBuilder("instruction2")
        .with("step", this.step + 1)
        .with("nextstep", this.step + 2);
    },
    mlInstruction3() {
      return new MLBuilder("instruction3")
        .with("step", this.step + 1)
        .with("nextstep", this.step + 2);
    },
    mlInstruction4() {
      return new MLBuilder("instruction4")
        .with("step", this.step + 1)
        .with("nextstep", this.step + 2);
    },
    mlInstruction5() {
      return new MLBuilder("instruction5")
        .with("step", this.step + 1)
        .with("nextstep", this.step + 2);
    },
    mlInstruction6() {
      let btnLabel;
      if (!this.$route.query.overview) btnLabel = this.$ml.get("btnNewSlide");
      else btnLabel = this.$ml.get("btnSaveSlide");
      return new MLBuilder("instruction6").with("label", btnLabel);
    },
  },
  async mounted() {
    // load user configs
    if (typeof this.selectedConfig !== "number") {
      console.error("!!!! No Config, go Back to your Dashboard and select one");
    } else {
      this.loadUserConfig();
    }
    // update steps
    this.updateSteps(this.possibleEffects);
    this.loadMusic();

    await this.$nextTick();
    if (typeof this.$route.query.overview !== "undefined") {
      this.nextStep(this.steps.length - 1);
    }
  },
  methods: {
    ...mapActions("configurations", [
      "updateSelectedConfig",
      "saveConfigurations",
    ]),
    isValidStep(step) {
      if (step === 0)
        return (
          typeof this.speedValue[step] === "undefined" ||
          typeof this.programValue[step] === "undefined"
        );
      if (step === 1)
        return (
          typeof this.speedValue[step] === "undefined" ||
          typeof this.colorValue[step] === "undefined" ||
          typeof this.programValue[step] === "undefined"
        );
      if (step === 2) return typeof this.speedValue[step] === "undefined";
      if (step === 3)
        return (
          typeof this.speedValue[step] === "undefined" ||
          typeof this.programValue[step] === "undefined"
        );
      if (step === 4) return typeof this.speedValue[step] === "undefined";
      return true;
      // typeof speedValue[step] === 'undefined'
    },
    updateName(newName) {
      if (newName.length !== 0) {
        this.rutschenName = newName;
        this.nextStep(0);
      }
    },
    changeSpeedValue(speed, index) {
      this.speedValue.splice(index, 1, speed);
    },
    changeSpeedValueMulti(speed, index, subIndex) {
      let stdValueArray = [];
      this.possibleEffects[index].params.map((elem) => {
        stdValueArray.push(webconfig.stdSpeed);
      });
      console.log(stdValueArray);
      this.speedChooserMultiSet = speed.value_description || "normal";
      let currentArray = this.speedValue[index] || stdValueArray;
      currentArray.splice(subIndex, 1, speed);
      this.speedValue.splice(index, 1, currentArray);
    },
    changeColorValue(color, index) {
      console.log(color, index);
      this.colorValue.splice(index, 1, color);
    },
    changeProgramValue(program, index) {
      this.programValue.splice(index, 1, program);
    },
    nextStep(dist) {
      let stepNumber = -1;
      if (typeof dist === "number") {
        stepNumber = dist;
      } else {
        stepNumber = this.steps.indexOf(dist);
      }
      if (stepNumber < -1) stepNumber = -1;
      if (stepNumber > this.possibleEffects.length)
        stepNumber = this.possibleEffects.length;
      this.step = stepNumber;
      // update completed step
      if (stepNumber > this.completedStep) {
        /*
          add values for not set effects
        */
        if (this.colorValue.length < stepNumber)
          this.colorValue.push(webconfig.stdColor);
        if (this.programValue.length < stepNumber)
          this.programValue.push(webconfig.stdProgram);
        if (this.speedValue.length < stepNumber)
          this.speedValue.push(webconfig.stdSpeed);
        /*
          values set - go on
        */
        this.completedStep = stepNumber;
      }
    },
    updateSteps(effects) {
      for (let i = 0; i < effects.length; i++) {
        this.steps.push(effects[i].id);
      }
      this.steps.push("music");
    },
    async saveConfig() {
      // build config object
      let obj = {
        slide_name: "ProSlide",
        mode: "time",
        config_name: this.rutschenName,
        music: this.selectedMusic || null,
        effects: [],
      };

      // fill it with the settings
      for (let i = 0; i < this.possibleEffects.length; i++) {
        let tmpObj = { id: "", params: [] };
        //falls bundled effects -> entbundeln
        console.log(this.possibleEffects);
        if (this.possibleEffects[i].bundledEffects) {
          console.log("bundled effect found");
          for (let j = 0; j < this.possibleEffects[i].params.length; j++) {
            let subObj = { id: "", params: [] };
            let speedVal = webconfig.stdSpeed.values[0];
            subObj.id = this.possibleEffects[i].params[j].sub_id;

            if (this.speedValue[i].length > j) speedVal = this.speedValue[i][j];
            subObj.params = subObj.params
              .concat(speedVal.values[0])
              .concat(webconfig.stdStrobe.values[0]);
            obj.effects.push(subObj);
          }
        } else {
          console.log("index ", i);
          console.table(this.speedValue[i]);
          console.table(this.colorValue[i]);
          console.table(this.programValue[i]);

          tmpObj.id = this.possibleEffects[i].id;
          tmpObj.params = tmpObj.params
            .concat(this.speedValue[i].values)
            .concat(this.colorValue[i].values)
            .concat(
              typeof this.programValue[i] !== "undefined"
                ? this.programValue[i].values
                : []
            );
          obj.effects.push(tmpObj);
        }
      }
      try {
        console.log("config: ", obj);
        // request
        await this.updateSelectedConfig(obj);
        await this.saveConfigurations();
        // console.log(response);
        this.$router.push("/");
      } catch (e) {
        console.log(e);
      }
    },
    loadUserConfig() {
      console.log("load user config...");
      let config = this.getConfigByIndex(this.selectedConfig);
      console.log("config", config);

      if (typeof config !== "undefined") {
        this.completedStep = this.possibleEffects.length;
        this.rutschenName = config.config_name;
        this.selectedMusic = config.music || null;
        //first of all unbundle the config of possible effects
        let unbundledConfig = [];
        let bundledEffectsIndex;
        for (let i = 0; i < this.possibleEffects.length; i++) {
          if (this.possibleEffects[i].bundledEffects) {
            bundledEffectsIndex = i;
            //bundle values from config and increase i to proceed
            this.possibleEffects[i].params.forEach((subEffect, idx) => {
              subEffect.id = subEffect.sub_id;
              unbundledConfig.push(subEffect);
            });
          } else {
            unbundledConfig.push(this.possibleEffects[i]);
          }
        }
        console.log("unbundled config", unbundledConfig);
        let indexForSlidePart = -1;
        for (let i = 0; i < unbundledConfig.length; i++) {
          //only increase when unbundled
          if (unbundledConfig[i].sub_id) {
            indexForSlidePart = bundledEffectsIndex;
          } else indexForSlidePart++;
          console.log("indexForSlidePart", indexForSlidePart);
          //some Programmabläufe might be missing -> add std value to avoid problems
          if (this.programValue.length < i) {
            this.programValue.push(webconfig.stdProgram);
          }
          let colorObj = { colorName: "", colorKey: "", values: [] };
          let speedObj = { value_description: "", values: [] };
          let programObj = { value_description: "", values: [] };

          for (let j = 0; j < config.effects[i].params.length; j++) {
            let key = config.effects[i].params[j].key;
            if (key === "Taktgeschwindigkeit") {
              switch (config.effects[i].params[j].value) {
                case 16:
                  speedObj.value_description = "sehr langsam";
                  break;
                case 8:
                  speedObj.value_description = "langsam";
                  break;
                case 4:
                  speedObj.value_description = "normal";
                  break;
                case 2:
                  speedObj.value_description = "schnell";
                  break;
                case 1:
                  speedObj.value_description = "sehr schnell";
                  break;
              }
              speedObj.values.push(config.effects[i].params[j]);
              if (unbundledConfig[i].sub_id) {
                this.speedValue[bundledEffectsIndex] =
                  this.speedValue[bundledEffectsIndex] || [];
                this.speedValue[bundledEffectsIndex].push(speedObj);
              } else this.speedValue[indexForSlidePart] = speedObj;
            } else if (key === "Programmablauf") {
              // value description
              switch (config.effects[i].params[j].value) {
                case 1:
                  programObj.value_description = "alle blinken";
                  break;
                case 2:
                  programObj.value_description = "eine Schlange rotiert";
                  break;
                case 12:
                  programObj.value_description = "3 Bänder";
                  break;
                case 13:
                  programObj.value_description = "hintereinander Aufleuchten";
                  break;
                case 15:
                  programObj.value_description = "dunkle Schlange";
                  break;
              }
              programObj.values.push(config.effects[i].params[j]);
              this.programValue[i] = programObj;
            } else {
              colorObj.values.push(config.effects[i].params[j]);
            }
          }

          //if unbundled value -> add stdColor
          if (unbundledConfig[i].sub_id) {
            this.colorValue[i] = webconfig.stdColor;
          } else {
            // find index of params
            try {
              let index01 = unbundledConfig[i].params.findIndex(
                (x) => x.param_name === "Farbe"
              );
              // find index of values
              let index02 = unbundledConfig[i].params[index01].values.findIndex(
                (x) =>
                  x.values.every(
                    (value, index) =>
                      value.value === colorObj.values[index].value
                  )
              );
              colorObj.colorName =
                unbundledConfig[i].params[index01].values[
                  index02
                ].value_description;
              this.colorValue[i] = colorObj;
            } catch (err) {
              console.log(
                "color adding crashed at index",
                unbundledConfig[i].id,
                "std value will be added"
              );
              this.colorValue[i] = webconfig.stdColor;
            }
          }
        }
      }
    },
    continueStep() {
      this.nextStep(++this.step);
      window.scrollTo(0, 0);
    },
    async loadMusic() {
      try {
        const songArray = this.songs;
        let options = [];
        for (let i = 0; i < songArray.length; i++) {
          if (songArray[i].url !== null) {
            options.push({
              value: songArray[i].id,
              text: songArray[i].title,
              url: songArray[i].url,
            });
          }
        }
        this.musicOptions = options;
      } catch (e) {
        console.log(e);
      }
    },
    updateMusicPath(newVal) {
      let option = this.musicOptions.find((x) => x.value === newVal);
      if (typeof option !== "undefined") this.selectedMusicPath = option.url;
      else this.selectedMusicPath = "";
    },
  },
};
</script>

<style scoped>
.configurator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #0b2137;
  min-height: 100vh;
  color: white;
}

.nav-btn {
  width: 150px;
}

.no-fixed-nav {
  position: absolute;
}

.fixed-pos {
  position: absolute;
  top: 0;
  left: 0;
}

.card.configurator-card {
  margin-top: 15vh;
  background: linear-gradient(to right, #0a345f, #0178b7);
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  border: none;
  padding: 0;
}

.configurator-card .card-body {
  padding: 0;
}

.card-head {
  display: flex;
  flex-direction: row;
  text-align: left;
  justify-content: space-between;
}

.head {
  font-size: 1.3rem;
}

.head {
  padding: 20px 30px 0;
}

.menu,
.description,
.effect {
  padding: 0 30px;
}

.configurator-wrapper {
  display: flex;
  flex-direction: row;
  margin-top: -16px;
}

.configurator-left {
  display: flex;
  flex-direction: column;
  width: 50%;
}

.configurator-left.tiles {
  flex-direction: column;
  align-items: center;
  border-right: 2px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 20px;
}

.configurator-right.music {
  display: flex;
  flex-direction: column;
}

.configurator-right {
  display: flex;
  flex-direction: row-reverse;
  width: 50%;
  justify-content: center;
}

.configurator-right .config-image {
  width: 100%;
  height: auto;
}

.menu {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

hr {
  border-top: 2px solid rgba(255, 255, 255, 0.1) !important;
}

.effect {
  width: 100%;
  align-items: center;
  margin-bottom: 20px;
}

@media (max-width: 768px) {
  .effect {
    width: 100%;
  }
}

.effect:first-child {
  padding-top: 40px;
}

.effect-headline {
  text-align: left;
  font-size: 1.1rem;
  font-weight: bold;
  margin-bottom: 10px;
}

.slider-info {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.menu-entry {
  font-size: 0.8rem;
  -webkit-border-radius: 40px;
  -moz-border-radius: 40px;
  border-radius: 40px;
  padding: 8px 12px;
}

.menu-entry:hover {
  cursor: pointer;
  background-color: #00a7ff;
}

.menu-entry.active {
  color: white;
  background: #00a7ff;
}

.menu-entry.disabled {
  pointer-events: none;
}

@media (min-width: 768px) {
  .menu-entry {
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    padding: 3px 12px;
  }

  .menu-entry:after {
    content: var(--abschnitt);
  }
  .menu-entry.music:after {
    content: var(--musik);
  }
  .menu-entry.start:after {
    content: "";
  }
}

.description {
  display: flex;
  flex-direction: row;
  text-align: left;
}

.description-container {
  width: 50%;
}

.description-picture {
  width: 50%;
  position: relative;
}

.description-picture img {
  width: 100%;
  margin-top: -16px;
  margin-right: -30px;
  margin-bottom: -16px;
}

.description-picture.overview-svg {
  width: 100%;
}

.overview {
  position: relative;
  width: auto;
  height: auto;
}

.bottom-hr {
  width: 100%;
}

@media (max-width: 991px) {
  .nav-btn {
    width: 100px;
  }
  .description-container {
    width: 100%;
  }
  .description {
    flex-direction: column;
  }

  .description-picture {
    width: 100%;
  }
  .description-picture img {
    margin: 0;
    align-self: center;
  }

  .desktop-hr {
    display: none;
  }

  .configurator-wrapper {
    flex-direction: column;
  }
  .configurator-left,
  .configurator-right {
    width: 100%;
  }

  .configurator-right .config-image {
    height: 80vw;
    width: 100%;
  }

  .desktop.navigation-buttons {
    display: none;
  }

  .navigation-buttons .btn {
    width: 115px;
  }
  .m-extended {
    width: 175px !important;
  }

  .mobile-fixed-menu {
    display: flex !important;
    flex-direction: row;
    justify-content: center;
    background: linear-gradient(to right, #0a345f, #0178b7);
    height: 80px;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9999;
    -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.75);
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.75);
  }

  .navigation-buttons {
    align-items: center;
    margin: 0;
  }

  .footer-buttons {
    margin-bottom: 20px;
  }

  .mobile-footer {
    min-height: 14vh;
  }
}

@media (max-width: 575px) {
  .configurator .container {
    width: 90%;
  }

  .footer-question {
    width: 100%;
  }

  .footer-buttons {
    flex-direction: column;
  }

  .footer-buttons .back-button {
    width: 100%;
  }

  /*
  .description-picture {
    display: none;
  }
   */
}

.footer-question {
  align-self: center;
  padding-right: 10px;
  color: rgba(255, 255, 255, 0.6);
}

.music img {
  width: 100%;
  height: auto;
}

.music-header {
  font-size: 1.3rem;
  font-weight: bold;
  padding-top: 20px;
  padding-left: 20px;
  align-self: flex-start;
}

.music-wrapper {
  margin-left: 10px;
  margin-right: 10px;
}

.music-select-wrapper {
  width: 100%;
  height: 100px;
  background-color: white;
  border-radius: 3px;
  align-self: center;
  color: black;
  text-align: left;
}

.music-description {
  margin-left: 10px;
  padding-top: 20px;
  font-weight: bold;
}

.mobile-fixed-menu {
  display: none;
}
</style>
